module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "students text-dark"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.isShowModal = true
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditSubject) + " " + _vm._s(_vm.studentCalendarIds.length) + " " + _vm._s(_vm.$t('vue2.students.of')) + " " + _vm._s(_vm.klassStudents.length) + " " + _vm._s(_vm.$t('vue2.students.students')) + "\n  ")]), _vm._v(" "), (_vm.isShowModal) ? _c('DModal', {
    attrs: {
      "show-close": false
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal__students",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.studentsSelected.length) + " " + _vm._s(_vm.$t('vue2.students.of')) + " " + _vm._s(_vm.klassStudents.length) + "\n          " + _vm._s(_vm.$t('vue2.students.students_in')) + " 1.a")]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": _vm.closeStudentModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-modal__content__add-student"
  }, [_c('transition-group'), _vm._v(" "), (!_vm.isAddStudentFromAnotherGroup) ? _c('p', {
    staticClass: "text-link",
    on: {
      "click": function($event) {
        _vm.isAddStudentFromAnotherGroup = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.students.add_student')))]) : _c('DSelect', {
    staticClass: "marg-1-bottom",
    attrs: {
      "items": _vm.studentsFromOtherGroups,
      "itemsSelected": [],
      "placeholder": _vm.$t('vue2.students.add_student'),
      "showSelectedUsers": false
    },
    on: {
      "add": function($event) {
        return _vm.addStudentToSubject($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "students__student__header border-1-bottom border-1-top"
  }, [_c('p', {
    on: {
      "click": _vm.selectAll
    }
  }, [(_vm.studentsSelected.length === _vm.klassStudents.length) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.unselect_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.select_all')))])])]), _vm._v(" "), _c('div', {
    staticClass: "border-1-bottom"
  }, [_c('ul', {
    staticClass: "students students__list"
  }, _vm._l((_vm.studentsSorted), function(student) {
    return _c('li', {
      staticClass: "students__student",
      on: {
        "click": function($event) {
          return _vm.toggleInStudentsSelected(student.id)
        }
      }
    }, [_c('div', {
      staticClass: "students__student__name"
    }, [_c('div', {
      staticClass: "d-checkbox",
      class: {
        'd-checkbox--active': _vm.isInStudentsSelected(student.id)
      }
    }), _vm._v(" "), _c('div', [_vm._v("\n                  " + _vm._s(student.name) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "student__grade"
    }, _vm._l((_vm.getStudentKlasses(student)), function(klass, key) {
      return _c('span', [(key > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" " + _vm._s(klass.name))])
    }), 0)])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "bttn bttn-simple marg-1-right",
    on: {
      "click": _vm.closeStudentModal
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10601e56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Students/StudentsOnSubject.vue
// module id = 1512
// module chunks = 1